import styled from "styled-components"

export const BasicInfoContainer = styled.div`
  // margin-top: 75px;
  @media (max-width: 767px) {
    margin-top: 40px;
  }
`
export const Title = styled.h2`
  font-family: "Roboto Slab";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  color: #000000;
  margin-bottom: 10px;
  width: 100%;
  @media (max-width: 991px) {
    font-size: 28px;
    line-height: 36px;
    max-width: 274px;
  }
`

export const InfoSec = styled.div`
  margin-bottom: 1em;
  @media (max-width: 767px) {
    margin-bottom: 0px;
  }
`
export const InfoCards = styled.ul`
  display: flex;
  flex-direction: column;
  @media (max-width: 767px) {
    flex-wrap: wrap;
  }
`
export const InfoCard = styled.ul`
  // height: 60px;
  background: #ffffff;
  border-bottom: 1px solid #ededed;
  border-radius: 0;
  padding: 13px 15px;
  display: flex;
  align-items: center;
  margin-right: 20px;
  @media (max-width: 991px) {
    padding-right: 0;
    padding-left: 0;
    margin-right: 0;
  }
  @media (max-width: 374px) {
    margin-right: 0px;
    width: 100%;
  }
`

export const IconCover = styled.span`
  // background: rgba(67, 135, 255, 0.12);
  // border-radius: 6px;
  // width: 40px;
  // height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 13px;
`

export const InfoCover = styled.div`
  -ms-flex: 1;
  flex: 1;
  h4 {
    font-family: "Roboto Slab";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 19px;
    color: #555555;
    margin-bottom: 0;
  }
  h5 {
    font-family: "Roboto Slab";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    color: #000308;
    margin-bottom: 0;
  }
`

export const Box = styled.div`
  p {
    font-size: small;
  }
`
